var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgHash = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M13.8287179,15.75 L9.33794876,15.75 L8.7454128,21.0828236 C8.69967057,21.4945038 8.32885648,21.791155 7.91717636,21.7454128 C7.50549623,21.6996706 7.20884496,21.3288565 7.2545872,20.9171764 L7.82871791,15.75 L4,15.75 C3.58578644,15.75 3.25,15.4142136 3.25,15 C3.25,14.5857864 3.58578644,14.25 4,14.25 L7.99538457,14.25 L8.49538457,9.75 L4,9.75 C3.58578644,9.75 3.25,9.41421356 3.25,9 C3.25,8.58578644 3.58578644,8.25 4,8.25 L8.66205124,8.25 L9.2545872,2.91717636 C9.30032943,2.50549623 9.67114352,2.20884496 10.0828236,2.2545872 C10.4945038,2.30032943 10.791155,2.67114352 10.7454128,3.08282364 L10.1712821,8.25 L14.6620512,8.25 L15.2545872,2.91717636 C15.3003294,2.50549623 15.6711435,2.20884496 16.0828236,2.2545872 C16.4945038,2.30032943 16.791155,2.67114352 16.7454128,3.08282364 L16.1712821,8.25 L20,8.25 C20.4142136,8.25 20.75,8.58578644 20.75,9 C20.75,9.41421356 20.4142136,9.75 20,9.75 L16.0046154,9.75 L15.5046154,14.25 L20,14.25 C20.4142136,14.25 20.75,14.5857864 20.75,15 C20.75,15.4142136 20.4142136,15.75 20,15.75 L15.3379488,15.75 L14.7454128,21.0828236 C14.6996706,21.4945038 14.3288565,21.791155 13.9171764,21.7454128 C13.5054962,21.6996706 13.208845,21.3288565 13.2545872,20.9171764 L13.8287179,15.75 Z M13.9953846,14.25 L14.4953846,9.75 L10.0046154,9.75 L9.50461543,14.25 L13.9953846,14.25 L13.9953846,14.25 Z"
  }));
};
export default SvgHash;